/**
 * Formata um valor numérico para moeda brasileira (BRL)
 * @param value Valor a ser formatado
 * @returns String formatada em BRL
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

export function formatCurrencyValue(value: number, currency: string): string {
  // Decide o locale baseado na moeda
  let locale = 'en-US';
  if (currency === 'BRL') locale = 'pt-BR';
  if (currency === 'EUR') locale = 'en-US'; // Euro normalmente é padrão europeu

  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

/**
 * Formata uma data para o formato brasileiro
 * @param date Data a ser formatada
 * @returns String formatada como dd/mm/yyyy
 */
export function formatDate(date: Date | string): string {
  if (!date) return '';

  const dateObj = typeof date === 'string' ? new Date(date) : date;

  return new Intl.DateTimeFormat('pt-BR').format(dateObj);
}

/**
 * Formata um CPF/CNPJ adicionando a máscara
 * @param value CPF ou CNPJ sem formatação
 * @returns CPF/CNPJ formatado
 */
export function formatDocument(value: string): string {
  if (!value) return '';

  // Remove todos os caracteres não numéricos
  const numbers = value.replace(/\D/g, '');

  // Verifica se é CPF ou CNPJ pelo tamanho
  if (numbers.length <= 11) {
    // CPF: 000.000.000-00
    return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else {
    // CNPJ: 00.000.000/0000-00
    return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
}
